import { PapiGruser } from '@wix/da-papi-types';
import camelCase from 'lodash/camelCase';

export const getModuleDataFromPapiResponse = (response: { gruser?: PapiGruser }) => {
  if (!response.gruser || !response.gruser.page || !Array.isArray(response.gruser.page.modules)) {
    return {};
  }

  const modulesMap: Record<string, any> = {};

  response.gruser.page.modules.forEach(module => {
    const { name: moduleName, moduleData } = module;
    if (!moduleName || !moduleData || !moduleData.dataKey) {
      return;
    }

    const dataKey = moduleData.dataKey;

    const actualModuleData = moduleData[camelCase(dataKey)];

    const camelModuleName = camelCase(moduleName);
    modulesMap[camelModuleName] = actualModuleData;
  });

  return modulesMap;
};
